document.addEventListener('DOMContentLoaded', (event) => {
    var coll = document.getElementsByClassName("collapsibleuz");
    for (var i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
            
            var plusMinus = this.querySelector('.plusminus');
            if (plusMinus) {
                plusMinus.classList.toggle('active');
            }
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {
  const backToTop = document.getElementById("backToTop");
  backToTop.addEventListener("click", function() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});



const initPrbar = () => {
  const obs = new IntersectionObserver(entries => entries.forEach(n => {
    if (!n.isIntersecting) return;
    let dur = +n.target.dataset.dur || 1500;
    n.target.querySelectorAll('.u-prbar-count-target').forEach(c => {
      let end = +c.dataset.final, start;
      const step = ts => { start = start || ts; let p = Math.min((ts - start) / dur, 1); c.innerText = Math.floor(p * end); p < 1 ? requestAnimationFrame(step) : c.innerText = end; };
      requestAnimationFrame(step);
    });
    n.target.querySelectorAll('.u-prbar-segments-row').forEach(r => {
      let v = +r.dataset.total;
      r.querySelectorAll('.u-prbar-fill').forEach((f, i) => setTimeout(() => f.style.width = (v > i * 25 ? Math.min((v - i * 25) * 4, 100) : 0) + '%', i * (dur / 10)));
    });
    obs.unobserve(n.target);
  }), { threshold: 0.1 });
  document.querySelectorAll('.u-prbar-wrapper').forEach(w => obs.observe(w));
};
['DOMContentLoaded', 'shopify:section:load'].forEach(e => document.addEventListener(e, initPrbar));


document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${mesi[futureDate.getMonth()]} ${futureDate.getDate()}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});


 var coll = document.getElementsByClassName("byumerzaman152");
  var i;
  for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
  this.classList.toggle("active");
  var content = this.nextElementSibling;
      if (content.style.maxHeight){
      content.style.maxHeight = null;
      } else {
      content.style.maxHeight = content.scrollHeight + "px";
      } 
  });
  }